/**
 * Dropdown
 * -----------------------------------------------------------------------------
 *
 * This is more like an accordion where content is revealed than a typical
 * dropdown that allows you to select an option/action.
 */

const dropItems = document.querySelectorAll( '.dropdown:not([data-no-js])' );



if ( dropItems.length ) {

  const targets               = document.querySelectorAll( '.dropdown__toggle' );
  const onDropdownToggleClick = function ( e ) {

    if ( this.parentNode.classList.contains( 'dropdown--active' ) ) {
      this.parentNode.classList.remove( 'dropdown--active' );
    } else {
      dropItems.forEach((dropItem) => {
        dropItem.classList.remove( 'dropdown--active' );
      });
      this.parentNode.classList.add('dropdown--active');
    }

  };



  targets.forEach( ( target ) => {
    target.addEventListener( 'click', onDropdownToggleClick );
  } );

  document.addEventListener( 'click', function ( e ) {

    dropItems.forEach( ( dropItem ) => {
      if ( !dropItem.contains( e.target ) ) {
        dropItem.classList.remove( 'dropdown--active' );
      }
    } );

  } );

}